import { createContext, useContext, useState, useEffect } from "react";

export const STR = {
  en: {
    navHome: "Home", navServices: "Services", navFleet: "My Fleet", navOneway: "One Way",
    navAllraj: "All Rajasthan", navTours: "Tour Packages", navGallery: "Gallery",
    navAbout: "About", navContact: "Contact", navBlog: "Blog",
    callNow: "Call Now", whatsappBooking: "WhatsApp Booking", topbarNote: "24/7 Booking",
    heroBadge: "Jodhpur · Rajasthan · 24/7",
    heroL1: "Reliable Taxi Service", heroL2a: "in ", heroL2b: "Jodhpur", heroL2c: " & All", heroL3: "of Rajasthan.",
    heroSub: "Book clean, comfortable and reliable taxis for local travel, one-way trips, airport transfers, outstation journeys and Rajasthan sightseeing.",
    bookTaxi: "BOOK A TAXI",
    wTitle: "Get Your Taxi Quote", wFree: "Free Quote", wPickup: "Pickup Location", wDrop: "Drop Location",
    wPassengers: "Passengers", wPassenger: "Passenger", wSubmit: "GET QUOTE ON WHATSAPP", wSending: "SENDING…", wOrCall: "or Call",
    trustEyebrow: "Why Blue City Taxi", trustTitle: "Travel Rajasthan With Complete Peace of Mind",
    svcEyebrow: "What We Do", svcTitle: "Taxi Services for Every Journey",
    svcText: "Local city rides to multi-day Rajasthan tours — one trusted cab partner for all of it.",
    svcAll: "View All 12 Services",
    cineEyebrow: "Cinematic Rajasthan", cineTitle: "Explore Rajasthan With Blue City Taxi",
    cineText: "Blue lanes of Jodhpur, the ramparts of Mehrangarh, Jaipur's pink facades, Udaipur's lakes, Jaisalmer's golden dunes and the green hills of Mount Abu — see it all from the comfort of your own private cab, with a local driver at the wheel.",
    cineBtn: "Explore Tour Packages",
    fleetEyebrow: "My Fleet", fleetTitle: "Clean Cars for Every Group Size",
    fleetText: "Sedans to tempo travellers — every vehicle air-conditioned, well-maintained and trip-ready.",
    fleetAll: "See Full Fleet",
    owEyebrow: "One Way Taxi", owTitle: "Pay One Side. Travel Anywhere.",
    owText: "One-way drops from Jodhpur to every major Rajasthan city — and Delhi. Fresh fare on every quote.",
    owAll: "All One-Way Routes",
    destEyebrow: "All Rajasthan", destTitle: "One Taxi Service. Every Destination.",
    destSub: "From the Blue City to the Golden Fort — we drive the whole state.",
    destAll: "All 23 Rajasthan Destinations",
    tourEyebrow: "Tour Packages", tourTitle: "Curated Rajasthan Journeys",
    tourText: "Sightseeing days to the complete royal circuit — request a quote and we plan it with you.",
    tourAll: "View All Tour Packages",
    revEyebrow: "Guest Reviews", revTitle: "What Our Travellers Say",
    revPlaceholder: "Google review will appear here", revGoogle: "View Us on Google",
    faqEyebrow: "Questions", faqTitle: "Frequently Asked Questions", faqAll: "Read all FAQs →",
    ctaTitle: "Ready to travel Rajasthan?",
    ctaText: "One call or WhatsApp message is all it takes. Share your route and date — we confirm your car, driver and fare.",
    whatsappNow: "WHATSAPP NOW",
    popTitle: "Taxi chahiye? 2 minute mein book karein",
    popSub: "Route batayein — latest fare aur gaadi ki detail turant WhatsApp par milegi. Koi advance payment nahi.",
    popPickup: "Pickup — e.g. Jodhpur Airport", popDrop: "Drop — e.g. Jaipur / Udaipur / Jaisalmer",
    popSubmit: "GET FARE ON WHATSAPP", popLater: "Baad mein dekhunga →",
    chatOnline: "Online — replies in minutes",
    chatHi: "Namaste! Kahan jaana hai? Route aur date bata dijiye — fare turant bhej dete hain.",
    chatPh: "Type your question…", chatWa: "Chat continues on WhatsApp",
    stickyCall: "CALL", stickyWa: "WHATSAPP", stickyBook: "BOOK",
    fBlurb: "A reliable taxi service based in Jodhpur, serving travellers across Rajasthan — local cabs, one-way drops, airport transfers, outstation journeys and full Rajasthan tours.",
    fServices: "Services", fCities: "Popular Cities", fRoutes: "Popular Routes",
    langBtn: "हिंदी",
    // Inner pages
    pSvcTitle: "Our Taxi Services",
    pSvcSub: "From a quick station pickup in Jodhpur to a two-week Rajasthan circuit — every service comes with a clean AC car, a professional local driver and transparent pricing.",
    pSvcEyebrow: "12 Services", pSvcHead: "One Cab Partner for Everything",
    svcCtaTitle: "Not sure which service fits your trip?",
    svcCtaText: "Tell us your plan on WhatsApp — we'll suggest the right vehicle and the most economical option.",
    pFleetTitle: "My Fleet",
    pFleetSub: "Every vehicle is air-conditioned, cleaned before your trip and driven by a professional local driver. Pick the category that fits your group and luggage.",
    pFleetEyebrow: "Choose Your Ride", pFleetHead: "Vehicles for 1 to 26 Travellers",
    fleetNote: "Vehicle models shown are indicative of each category. Share your preference on WhatsApp and we'll confirm the exact available vehicle for your date.",
    fleetCtaTitle: "Need help picking a vehicle?",
    fleetCtaText: "Tell us your group size, luggage and route — we'll recommend the most comfortable and economical option.",
    fSeats: "Seats", fLuggage: "Luggage", fClimate: "Climate", fBestFor: "Best for:", fBook: "Book Now",
    fDriver: "Driver", fDriverInc: "Included",
    chip1: "Clean AC Cars", chip2: "Verified Local Drivers", chip3: "No Hidden Charges", chip4: "24×7 Support",
    wSecTitle: "Book Your Taxi in 2 Minutes",
    wSecSub: "Fill the trip details — get availability and the latest fare on WhatsApp instantly. No advance payment.",
    pTourTitle: "Rajasthan Tour Packages",
    pTourSub: "Private cab tours with a driver who stays with you from day one to drop-off. Fully customisable — these packages are starting points, not fixed itineraries.",
    pTourEyebrow: "9 Journeys", pTourHead: "Choose Your Rajasthan Story",
    pTourText: "No fixed price lists — every tour is quoted fresh for your dates, group size and vehicle choice.",
    tourNote: "Every package includes a private AC vehicle, professional driver, fuel and driver allowance as per quote. Hotels, entry tickets and meals are kept flexible so you choose your own style.",
    tourVehicles: "Vehicle options: Sedan · SUV · Premium SUV · Tempo Traveller",
    tourQuote: "Request Quote",
    cLocal: "Local Taxi Services", cAirport: "Airport & Railway Pickup",
    cOut: "Outstation & One-Way Taxi", cSight: "Sightseeing Cabs",
    cAttr: "Popular Attractions in {city}", cRoutes: "Popular Routes",
    cWhy: "Why Choose Blue City Taxi in {city}?", cFaq: "FAQs", cOther: "Other Cities",
    cBook: "Book a Taxi in {city}",
    cSightText: "Book a full-day or half-day sightseeing cab in {city} with a driver who knows the viewpoints, the timings and the stories behind them.",
    cCtaTitle: "Need a taxi in {city} today?",
    cCtaText: "Call or WhatsApp — we'll confirm your {city} cab, driver and fare in minutes.",
    cHeroSub: "local cabs, airport & station transfers, sightseeing and outstation taxis by Blue City Taxi, Jodhpur.",
    // Blog
    blogEyebrow: "Travel Blog", blogTitle: "Rajasthan Travel Guides",
    blogSub: "Routes, itineraries and local tips from drivers who run these roads every week.",
    readMore: "Read Guide", backBlog: "All guides", relatedBlog: "Keep Reading",
    blogCtaTitle: "Planning a Rajasthan trip after reading?",
    blogCtaText: "WhatsApp us your route and dates — we'll suggest the right vehicle and share the latest fare.",
  },
  hi: {
    navHome: "होम", navServices: "सर्विसेज़", navFleet: "मेरी गाड़ियाँ", navOneway: "वन-वे",
    navAllraj: "पूरा राजस्थान", navTours: "टूर पैकेज", navGallery: "गैलरी",
    navAbout: "हमारे बारे में", navContact: "संपर्क", navBlog: "ब्लॉग",
    callNow: "कॉल करें", whatsappBooking: "WhatsApp बुकिंग", topbarNote: "24/7 बुकिंग",
    heroBadge: "जोधपुर · राजस्थान · 24/7",
    heroL1: "भरोसेमंद टैक्सी सर्विस", heroL2a: "", heroL2b: "जोधपुर", heroL2c: " और पूरे", heroL3: "राजस्थान में।",
    heroSub: "लोकल ट्रैवल, वन-वे ट्रिप, एयरपोर्ट ट्रांसफर, आउटस्टेशन सफर और राजस्थान दर्शन के लिए साफ, आरामदायक और भरोसेमंद टैक्सी बुक करें।",
    bookTaxi: "टैक्सी बुक करें",
    wTitle: "अपनी टैक्सी का भाड़ा जानें", wFree: "फ्री कोट", wPickup: "पिकअप लोकेशन", wDrop: "ड्रॉप लोकेशन",
    wPassengers: "यात्री", wPassenger: "यात्री", wSubmit: "WHATSAPP पर भाड़ा पाएं", wSending: "भेजा जा रहा है…", wOrCall: "या कॉल करें",
    trustEyebrow: "Blue City Taxi क्यों", trustTitle: "बेफिक्र होकर राजस्थान घूमिए",
    svcEyebrow: "हम क्या करते हैं", svcTitle: "हर सफर के लिए टैक्सी सर्विस",
    svcText: "शहर की छोटी राइड से लेकर कई दिनों के राजस्थान टूर तक — सबके लिए एक भरोसेमंद कैब पार्टनर।",
    svcAll: "सभी 12 सर्विसेज़ देखें",
    cineEyebrow: "सिनेमैटिक राजस्थान", cineTitle: "Blue City Taxi के साथ राजस्थान घूमिए",
    cineText: "जोधपुर की नीली गलियाँ, मेहरानगढ़ की विशाल दीवारें, जयपुर की गुलाबी इमारतें, उदयपुर की झीलें, जैसलमेर के सुनहरे रेत के टीले और माउंट आबू की हरी पहाड़ियाँ — अपनी प्राइवेट कैब और स्थानीय ड्राइवर के साथ सब कुछ देखिए।",
    cineBtn: "टूर पैकेज देखें",
    fleetEyebrow: "मेरी गाड़ियाँ", fleetTitle: "हर ग्रुप साइज़ के लिए साफ गाड़ियाँ",
    fleetText: "सेडान से टेम्पो ट्रैवलर तक — हर गाड़ी एयर-कंडीशन्ड, अच्छी हालत और ट्रिप के लिए तैयार।",
    fleetAll: "पूरा फ़्लीट देखें",
    owEyebrow: "वन-वे टैक्सी", owTitle: "एक तरफ का किराया। मंज़िल कहीं भी।",
    owText: "जोधपुर से राजस्थान के हर बड़े शहर — और दिल्ली — तक वन-वे ड्रॉप। हर बार ताज़ा भाड़ा।",
    owAll: "सभी वन-वे रूट देखें",
    destEyebrow: "पूरा राजस्थान", destTitle: "एक टैक्सी सर्विस। हर मंज़िल।",
    destSub: "ब्लू सिटी से गोल्डन फोर्ट तक — हम पूरा राजस्थान चलाते हैं।",
    destAll: "राजस्थान के सभी 23 डेस्टिनेशन",
    tourEyebrow: "टूर पैकेज", tourTitle: "चुनिंदा राजस्थान यात्राएँ",
    tourText: "एक दिन की sightseeing से लेकर पूरे राजस्थान के टूर तक — कोट माँगिए, हम आपके साथ प्लान बनाएंगे।",
    tourAll: "सभी टूर पैकेज देखें",
    revEyebrow: "मेहमानों की राय", revTitle: "हमारे यात्री क्या कहते हैं",
    revPlaceholder: "Google review यहाँ दिखेगा", revGoogle: "Google पर हमें देखें",
    faqEyebrow: "सवाल-जवाब", faqTitle: "अक्सर पूछे जाने वाले सवाल", faqAll: "सभी सवाल-जवाब पढ़ें →",
    ctaTitle: "राजस्थान घूमने के लिए तैयार?",
    ctaText: "एक कॉल या WhatsApp मैसेज काफी है — रूट और तारीख बताइए, हम गाड़ी, ड्राइवर और भाड़ा कन्फर्म कर देंगे।",
    whatsappNow: "WHATSAPP करें",
    popTitle: "टैक्सी चाहिए? 2 मिनट में बुक करें",
    popSub: "रूट बताइए — ताज़ा भाड़ा और गाड़ी की डिटेल तुरंत WhatsApp पर मिलेगी। कोई एडवांस पेमेंट नहीं।",
    popPickup: "पिकअप — जैसे जोधपुर एयरपोर्ट", popDrop: "ड्रॉप — जैसे जयपुर / उदयपुर / जैसलमेर",
    popSubmit: "WHATSAPP पर भाड़ा पाएं", popLater: "बाद में देखूँगा →",
    chatOnline: "ऑनलाइन — कुछ मिनट में जवाब",
    chatHi: "नमस्ते! कहाँ जाना है? रूट और तारीख बता दीजिए — भाड़ा तुरंत भेज देते हैं।",
    chatPh: "अपना सवाल लिखें…", chatWa: "चैट WhatsApp पर जारी होगी",
    stickyCall: "कॉल", stickyWa: "WHATSAPP", stickyBook: "बुक",
    fBlurb: "जोधपुर में स्थित एक भरोसेमंद टैक्सी सर्विस — पूरे राजस्थान में लोकल कैब, वन-वे ड्रॉप, एयरपोर्ट ट्रांसफर, आउटस्टेशन सफर और राजस्थान टूर।",
    fServices: "सर्विसेज़", fCities: "लोकप्रिय शहर", fRoutes: "लोकप्रिय रूट",
    langBtn: "English",
    // Inner pages
    pSvcTitle: "हमारी टैक्सी सर्विसेज़",
    pSvcSub: "जोधपुर के स्टेशन पिकअप से लेकर दो हफ्ते के राजस्थान सर्किट तक — हर सर्विस के साथ साफ AC गाड़ी, प्रोफेशनल स्थानीय ड्राइवर और पारदर्शी कीमत।",
    pSvcEyebrow: "12 सर्विसेज़", pSvcHead: "हर काम के लिए एक कैब पार्टनर",
    svcCtaTitle: "समझ नहीं आ रहा कौन-सी सर्विस सही है?",
    svcCtaText: "WhatsApp पर अपना प्लान बताइए — हम सही गाड़ी और सबसे किफ़ायती विकल्प सुझा देंगे।",
    pFleetTitle: "मेरी गाड़ियाँ",
    pFleetSub: "हर गाड़ी एयर-कंडीशन्ड, ट्रिप से पहले साफ और प्रोफेशनल स्थानीय ड्राइवर के साथ। अपने ग्रुप और सामान के हिसाब से कैटेगरी चुनें।",
    pFleetEyebrow: "अपनी गाड़ी चुनें", pFleetHead: "1 से 26 यात्रियों की गाड़ियाँ",
    fleetNote: "दिखाए गए मॉडल हर कैटेगरी के संकेत मात्र हैं। WhatsApp पर अपनी पसंद बताएं — हम आपकी तारीख पर उपलब्ध सही गाड़ी कन्फर्म करेंगे।",
    fleetCtaTitle: "गाड़ी चुनने में मदद चाहिए?",
    fleetCtaText: "ग्रुप साइज़, सामान और रूट बताइए — हम सबसे आरामदायक और किफ़ायती विकल्प बता देंगे।",
    fSeats: "सीटें", fLuggage: "सामान", fClimate: "एसी", fBestFor: "किसके लिए:", fBook: "बुक करें",
    fDriver: "ड्राइवर", fDriverInc: "सहित",
    chip1: "साफ AC गाड़ियाँ", chip2: "वेरिफाइड लोकल ड्राइवर", chip3: "कोई छिपा चार्ज नहीं", chip4: "24×7 सपोर्ट",
    wSecTitle: "2 मिनट में अपनी टैक्सी बुक करें",
    wSecSub: "ट्रिप की डिटेल भरें — WhatsApp पर तुरंत availability और ताज़ा भाड़ा पाएं। कोई एडवांस पेमेंट नहीं।",
    pTourTitle: "राजस्थान टूर पैकेज",
    pTourSub: "प्राइवेट कैब टूर — ड्राइवर पहले दिन से ड्रॉप तक साथ रहता है। पूरी तरह कस्टमाइज़ेबल; ये पैकेज सिर्फ शुरुआत हैं, फिक्स्ड इटिनररी नहीं।",
    pTourEyebrow: "9 यात्राएँ", pTourHead: "अपनी राजस्थान कहानी चुनें",
    pTourText: "कोई फिक्स्ड रेट लिस्ट नहीं — हर टूर आपकी तारीख, ग्रुप साइज़ और गाड़ी के हिसाब से ताज़ा कोट होता है।",
    tourNote: "हर पैकेज में प्राइवेट AC गाड़ी, प्रोफेशनल ड्राइवर, तेल और ड्राइवर भत्ता कोट के अनुसार शामिल है। होटल, एंट्री टिकट और खाना आपकी पसंद पर छोड़ा गया है।",
    tourVehicles: "गाड़ी के विकल्प: सेडान · SUV · प्रीमियम SUV · टेम्पो ट्रैवलर",
    tourQuote: "कोट माँगें",
    cLocal: "लोकल टैक्सी सर्विस", cAirport: "एयरपोर्ट व रेलवे पिकअप",
    cOut: "आउटस्टेशन व वन-वे टैक्सी", cSight: "दर्शन (Sightseeing) कैब",
    cAttr: "{city} के लोकप्रिय आकर्षण", cRoutes: "लोकप्रिय रूट",
    cWhy: "{city} में Blue City Taxi ही क्यों?", cFaq: "सवाल-जवाब", cOther: "अन्य शहर",
    cBook: "{city} में टैक्सी बुक करें",
    cSightText: "{city} में पूरे दिन या आधे दिन की sightseeing कैब बुक करें — ड्राइवर व्यूपॉइंट, समय और उनके पीछे की कहानियाँ अच्छी तरह जानता है।",
    cCtaTitle: "आज {city} में टैक्सी चाहिए?",
    cCtaText: "कॉल या WhatsApp करें — हम {city} की गाड़ी, ड्राइवर और भाड़ा कुछ मिनट में कन्फर्म कर देंगे।",
    cHeroSub: "लोकल कैब, एयरपोर्ट व स्टेशन ट्रांसफर, sightseeing और आउटस्टेशन टैक्सी — Blue City Taxi, जोधपुर द्वारा।",
    // Blog
    blogEyebrow: "ट्रैवल ब्लॉग", blogTitle: "राजस्थान ट्रैवल गाइड",
    blogSub: "रूट, इटिनररी और स्थानीय टिप्स — उन ड्राइवरों से जो हर हफ्ते इन सड़कों पर चलते हैं।",
    readMore: "गाइड पढ़ें", backBlog: "सभी गाइड", relatedBlog: "आगे पढ़ें",
    blogCtaTitle: "पढ़ने के बाद राजस्थान ट्रिप की योजना बन रही है?",
    blogCtaText: "WhatsApp पर अपना रूट और तारीख बताइए — सही गाड़ी सुझाएंगे और ताज़ा भाड़ा भेजेंगे।",
  },
};

export const TRUST_HI = [
  { icon: "ShieldCheck", title: "अनुभवी ड्राइवर", text: "स्थानीय ड्राइवर जो राजस्थान के रास्ते, रूट और ठहरने की जगहें अच्छी तरह जानते हैं।" },
  { icon: "Sparkles", title: "साफ और आरामदायक गाड़ियाँ", text: "हर ट्रिप से पहले साफ की गई, अच्छी हालत वाली एयर-कंडीशन्ड गाड़ियाँ।" },
  { icon: "BadgeIndianRupee", title: "पारदर्शी कीमत", text: "बुकिंग से पहले साफ भाड़ा। कोई छिपा हुआ चार्ज नहीं, कोई झंझट नहीं।" },
  { icon: "Clock", title: "समय पर पिकअप", text: "आपका ड्राइवर वादे के मुताबिक पहुंचता है — एयरपोर्ट, स्टेशन, होटल या घर।" },
  { icon: "Headphones", title: "24/7 बुकिंग सहायता", text: "कभी भी कॉल या WhatsApp करें। हम हर समय आपकी मदद के लिए मौजूद हैं।" },
  { icon: "MapPin", title: "राजस्थान के स्थानीय जानकार", text: "जोधपुर में स्थित — राजस्थान के हर कोने की सफर-जानकारी हमारे पास।" },
];

export const CHIPS_HI = ["वन-वे टैक्सी का भाड़ा?", "एयरपोर्ट पिकअप चाहिए", "राजस्थान टूर पैकेज", "जोधपुर sightseeing कैब"];
export const CHIPS_EN = ["One-way taxi ka fare?", "Airport pickup chahiye", "Rajasthan tour package", "Jodhpur sightseeing cab"];

const LangCtx = createContext({ lang: "en", t: (k) => k, toggle: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("bct_lang") || "en");
  useEffect(() => {
    localStorage.setItem("bct_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => STR[lang][key] ?? STR.en[key] ?? key;
  const toggle = () => setLang((l) => (l === "en" ? "hi" : "en"));
  return <LangCtx.Provider value={{ lang, t, toggle }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
